module.exports = {"credits-0":"<em>credits</em>: Aleksei Beloys, Olga Polevikova,Alexandra Davidenko,Marianna Rydakova, Olga Kaskevich, Konstantin Chikalov, Egor Kvartalnii","credits-1":"<em>animation</em>: <a href='https://vimeo.com/search?q=kniknistudio'>Knikni studio</a>","description":"","title":"A video about the consequences <br/>of the E40 waterway construction"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/film.en.json
// module id = 160
// module chunks = 0